import React from 'react';
import styles from './Community.module.css';

const APIDocs = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>

        <div className={styles.messageBox}>
          <h2 className={styles.messageTitle}> Building our Community of Financial Geeks</h2>
        </div>

      </div>
    </div>
  );
};

export default APIDocs;